// extracted by mini-css-extract-plugin
module.exports = {"root":"PriceFilterPopup_root__12fSE","label":"PriceFilterPopup_label__3Yh64","labelSelected":"PriceFilterPopup_labelSelected__2u8VT"};